import React from "react";
import Navbar from "../Navbar/Navbar";
import styles from "./css/Thankyou.module.css";
import img from "../assets/thank-you.png";
import { useNavigate } from "react-router-dom";

export default function Thankyou() {

const navigate =  useNavigate();
  return (
    <>
      <div className={styles.ladningbg}>
        <Navbar />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className={styles.box}>
          <img src={img} style={{ marginTop: 100 }} />
          <h5
            style={{
              textAlign: "center",
              fontFamily: "Inter, sans-serif",
              fontWeight: "600",
              marginTop: 30,
            }}
          >
            Thanks for reaching out!
          </h5>
          <p
            style={{
              textAlign: "center",
              color: "#6A6A6A",
              fontFamily: "Inter, sans-serif",
              padding: 10,
              fontSize: 12,
            }}
          >
            We'll be in touch shortly and look forward to discussing how House
            Care online can best support your business.
          </p>

          <button
            style={{
              width: "90%",
              height: 50,
              border: "none",
              fontFamily: "Inter, sans-serif",
              fontWeight: "600",
              borderRadius: 10,
              background: "#07448E",
              color: "#fff",
            }}

            onClick={() => navigate("/")} // Navigate to home page
          >
            Go Back Home
          </button>
        </div>
      </div>
    </>
  );
}
